import React, { useEffect, useState } from "react";
import { client } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";

const LABEL = "font-condensed uppercase tracking-wider text-[12px] font-semibold";

export function EditNameDialog({ person, onClose, onSaved }) {
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (!person) return;
    setFirst(person.first_name || ""); setLast(person.last_name || "");
  }, [person]);
  if (!person) return null;

  const save = async () => {
    try {
      setSaving(true);
      await client.patch(`/users/${person.user_id}`, { first_name: first, last_name: last });
      toast.success("Name updated");
      onSaved();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update the name");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={value => { if (!value) onClose(); }}>
      <DialogContent className="max-w-[420px]" data-testid="edit-name-dialog">
        <DialogHeader>
          <DialogTitle>Edit name</DialogTitle>
          <DialogDescription>
            <span className="mono">{person.email}</span> · the email address cannot be changed.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className={LABEL} style={{ color: "#5B6472" }}>First name</Label>
            <Input className="mt-1 rounded-[10px]" value={first} onChange={e => setFirst(e.target.value)} data-testid="edit-name-first" />
          </div>
          <div>
            <Label className={LABEL} style={{ color: "#5B6472" }}>Last name</Label>
            <Input className="mt-1 rounded-[10px]" value={last} onChange={e => setLast(e.target.value)} data-testid="edit-name-last" />
          </div>
        </div>
        <DialogFooter className="mt-3">
          <Button variant="outline" className="bf-btn-ghost" onClick={onClose} data-testid="edit-name-cancel">Cancel</Button>
          <Button className="bf-btn-primary px-4" disabled={saving || !first.trim() || !last.trim()} onClick={save}
                  data-testid="edit-name-save">Save name</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
